import { render } from "./AILabsPage.vue?vue&type=template&id=7ca9f1eb"
import script from "./AILabsPage.vue?vue&type=script&lang=js"
export * from "./AILabsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__